import React, { useEffect, useRef, useState } from 'react';
import { subscribeToAlerts } from '../utils/alertBus';

const TYPE_STYLES = {
  success: 'bg-emerald-600 text-white',
  error: 'bg-red-600 text-white',
  warning: 'bg-amber-500 text-white',
  info: 'bg-slate-800 text-white',
};

const AppAlerts = () => {
  const [alerts, setAlerts] = useState([]);
  const nextId = useRef(0);
  const timers = useRef(new Map());

  const removeAlert = (id) => {
    setAlerts((prev) => prev.filter((alert) => alert.id !== id));
    const timer = timers.current.get(id);
    if (timer) {
      clearTimeout(timer);
      timers.current.delete(id);
    }
  };

  useEffect(() => {
    const unsubscribe = subscribeToAlerts((payload) => {
      const id = nextId.current + 1;
      nextId.current = id;
      const entry = {
        id,
        message: payload?.message || '',
        type: payload?.type || 'info',
        duration: payload?.duration,
      };
      setAlerts((prev) => [...prev, entry]);

      const duration =
        typeof entry.duration === 'number' && Number.isFinite(entry.duration)
          ? entry.duration
          : 4500;
      if (duration > 0) {
        const timer = setTimeout(() => removeAlert(id), duration);
        timers.current.set(id, timer);
      }
    });

    return () => {
      unsubscribe();
      timers.current.forEach((timer) => clearTimeout(timer));
      timers.current.clear();
    };
  }, []);

  if (alerts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-3 w-80 max-w-[90vw]" aria-live="polite">
      {alerts.map((alert) => {
        const tone = TYPE_STYLES[alert.type] || TYPE_STYLES.info;
        return (
          <div
            key={alert.id}
            className={`rounded-xl shadow-lg px-4 py-3 flex items-start gap-3 ${tone}`}
            role="status"
          >
            <div className="flex-1 text-sm whitespace-pre-line">{alert.message}</div>
            <button
              type="button"
              onClick={() => removeAlert(alert.id)}
              className="text-white/80 hover:text-white transition"
              aria-label="Cerrar alerta"
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default AppAlerts;
